import { OptionsViewModel, JWTViewModel } from '@models/common.models';
import { CommentViewModel } from '@models/Comment';
import { BaseService } from '@services/BaseService';
import { LoginResponse } from '@models/Auth';

class AuthService extends BaseService {
  constructor() {
    super('auth');
  }

  login(username: string, password: string): Promise<LoginResponse> {
    // Get a token from api server using the fetch api
    return this.fetch<LoginResponse>('Token', {
      method: 'POST',
      body: JSON.stringify({
        username: username,
        password: password
      })
    });
  }

  getCompanies(): Promise<OptionsViewModel[]> {
    return this.fetch<OptionsViewModel[]>('Companies', {
      method: 'GET'
    });
  }

  isLoggedIn(): Promise<JWTViewModel> {
    return this.fetch<JWTViewModel>(`LoggedIn`, {
      method: 'GET'
    });
  }

  userActions(pageNumber: number, pageSize: number, orderDirection: string) {
    return this.fetch<CommentViewModel[]>('user/actions', {
      method: 'POST',
      body: JSON.stringify({
        query: '',
        pageSize: pageSize,
        pageNumber: pageNumber,
        orderDirection: orderDirection,
        orderBy: ''
      })
    });
  }

  public getRoleOptions(): Promise<Array<OptionsViewModel>> {
    return this.fetch<Array<OptionsViewModel>>('roles', {
      method: 'GET'
    });
  }

  public mockUser(mockedUserId: number): Promise<LoginResponse> {
    return this.fetch<LoginResponse>(`MockUser?mockedUserId=${mockedUserId}`, {
      method: 'PUT'
    });
  }

  public stopMocking(): Promise<LoginResponse> {
    return this.fetch<LoginResponse>('StopMocking', {
      method: 'DELETE'
    });
  }
}

export const authService = new AuthService();



// WEBPACK FOOTER //
// ./src/_services/AuthService.ts